import React, { Component } from 'react';
import swal from 'sweetalert2';
import { Form } from 'react-form';
import { reinitialiserMdpE1 } from '../../../App_Code/API';
import { estEmailValide } from '../../../App_Code/Utils';
import * as HttpStatus from '../../../App_Data/HttpStatus';
import { AfficherFeedback, Texte } from '../../ChampFormulaire';

class PageMdpOublie extends Component {
    constructor(props) {
        super(props);

        this.emailInput = React.createRef();
        this.envoyerInput = React.createRef();
    }

    handleSubmit = (submittedValues) => {
        const { email } = submittedValues;
        const { history } = this.props;
        this.envoyerInput.current.disabled = true;

        const emailValide = estEmailValide(email);
        AfficherFeedback(this.emailInput, emailValide);

        if (!emailValide) {
            this.envoyerInput.current.disabled = false;
            return;
        }

        reinitialiserMdpE1(email).then((response) => {
            if (response.status === HttpStatus.OK) {
                history.push({
                    pathname: '/MotdepasseOublie/Valide',
                    search: `email=${encodeURIComponent(email)}`,
                });
            } else {
                swal({
                    type: 'error',
                    title: 'Erreur',
                    text: "Impossible d'envoyer l'e-mail de récupération de mot de passe.",
                    footer: response.data.Message.replace(/["]+/g, ''),
                });
                AfficherFeedback(this.emailInput, false);
                this.envoyerInput.current.disabled = false;
            }
        });
    };

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <h5 className="card-title">Mot de passe oublié</h5>
                        <div className="form-group required">
                            <label htmlFor="MdpOublieEmail">E-mail</label>
                            <Texte
                                id="MdpOublieEmail"
                                field="email"
                                placeholder="E-mail"
                                type="email"
                                refRef={this.emailInput}
                            />
                            <div className="invalid-feedback">Veuillez renseigner votre e-mail</div>
                        </div>
                        <button type="submit" className="btn btn-block btn-lg btn-success" ref={this.envoyerInput}>
                            Envoyer l&apos;email
                        </button>
                    </form>
                )}
            </Form>
        );
    }
}

export default PageMdpOublie;



// WEBPACK FOOTER //
// ./src/components/Adherent/MdpOublie/index.js